import React from 'react';
import Header from 'components/Header';
import Routes from 'routes';
import { connect } from 'react-redux';
import { initialized,  } from 'actions/app';
import { loginSuccess, logoutRequest } from 'actions/auth';
import { history } from 'store';
import { ConnectedRouter } from 'connected-react-router';
import { fetchPendingLoanApplication } from 'actions/app';

class App extends React.Component {
	componentDidMount(){
		const { dispatch } = this.props;
		let token = localStorage.getItem('e_3235');
		if ( token ) {
			//Token found, then validate if is still valid
			dispatch(fetchPendingLoanApplication())
				.then(() => {
					dispatch(loginSuccess({token}));
					dispatch(initialized());
				})
				.catch(() => {
					dispatch(logoutRequest());
					dispatch(initialized());
				});
		} else {
			dispatch(initialized());
		}
	}
	render(){
		return <ConnectedRouter history={history}>
			<React.Fragment>
				<Header />
				<div className="background-gradient" />
				<Routes />
			</React.Fragment>
		</ConnectedRouter>
	}
}

export default App = connect()(App);



// WEBPACK FOOTER //
// ./src/containers/App.jsx